import { action, makeObservable, observable } from "mobx"

import type { ISwapExecutionStore } from "./interfaces"

/**
 * Swap Execution Store
 * Manages swap execution state (approval, transaction, confirmation)
 * Uses MobX for reactivity
 */
export class SwapExecutionStore implements ISwapExecutionStore {
  state: "idle" | "approving" | "swapping" | "success" | "error" = "idle"
  error: string | null = null

  constructor() {
    makeObservable(this, {
      state: observable,
      error: observable,
      startApproval: action,
      startSwap: action,
      complete: action,
      setError: action,
      reset: action,
    })
  }

  startApproval(): void {
    this.state = "approving"
    this.error = null
  }

  startSwap(): void {
    this.state = "swapping"
    this.error = null
  }

  complete(): void {
    this.state = "success"
    this.error = null
  }

  setError(error: string | null): void {
    // If error contains "user rejected the request", treat it as a silent error
    // User intentionally cancelled, so don't show error message but still set error state
    // so the UI can show the reset button
    if (error && error.toLowerCase().includes("user rejected the request")) {
      this.error = null
      this.state = "error"
      return
    }

    this.error = error
    if (error) {
      this.state = "error"
    }
  }

  reset(): void {
    this.state = "idle"
    this.error = null
  }
}
